import { calculateAgeForEnrollment } from '@zorro/common-utils';
import { DateUtilInstance, formatDateISO } from '@zorro/shared/formatters';

export const calculateAgeAtPlanStart = (
  dateOfBirth?: Date | DateUtilInstance,
  targetEnrollmentDate?: Date | DateUtilInstance
): number | undefined => {
  if (!dateOfBirth || !targetEnrollmentDate) {
    return undefined;
  }
  return calculateAgeForEnrollment(
    formatDateISO(dateOfBirth),
    formatDateISO(targetEnrollmentDate)
  );
};

export const getPhoneVariations = (phone?: string | null) => {
  if (!phone) {
    return {
      valueForView: phone,
      valueForCopy: phone,
    };
  }

  const digits = phone.replace(/\D/gu, '');
  const phoneNumber = digits.slice(-10);

  return {
    valueForView: `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`,
    valueForCopy: phoneNumber,
  };
};
